<div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="row dialog-header">
    <div class="col-11 left">
        <h4>{{ 'projects.general.select' | translate }}</h4>
    </div>
    <div class="col-1 right">
        <button (click)="dialogRef.close()">
            <i class="a-icon a-icon--close"></i>
        </button>
    </div>
</div>
<div class="row">
    <div class="col-6">
        <mat-form-field class="mat-custom" appearance="fill">
            <mat-label>{{ 'projects.general.searchdot' | translate }}</mat-label>
            <input [formControl]="searchControl" matInput />
            @if (searchControl.value && searchControl.value !== '') {
                <button aria-label="Clear" mat-icon-button matSuffix (click)="searchControl.reset()">
                    <i class="material-icons">close</i>
                </button>
            }
        </mat-form-field>
    </div>
</div>
<div class="row main-content" [hidden]="projectSelectionService.loading$ | async">
    <div class="col-12">
        <div class="table-container">
            <mat-table [dataSource]="projects" matSort (matSortChange)="sortChanged($event)">
                <ng-container matColumnDef="selected">
                    <mat-header-cell *matHeaderCellDef>
                        @if (multiple) {
                            @if (!fewSelected) {
                                <mat-checkbox
                                    (change)="selectAll()"
                                    [ngModel]="allChecked"
                                    (ngModelChange)="onAllCheckedChange($event)"
                                ></mat-checkbox>
                            }
                            @if (fewSelected) {
                                <mat-checkbox (change)="selectAll()" class="mat-checkbox-semichecked"></mat-checkbox>
                            }
                        }
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <mat-checkbox
                            (change)="changeSelected(element, $event)"
                            [checked]="element | projectSelected: selectedProjects"
                        ></mat-checkbox>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="mpNumber">
                    <mat-header-cell
                        filter
                        *matHeaderCellDef
                        [sort]="true"
                        name="{{ 'columns.mpNumber' | translate }}"
                        [filter]="filterService.getColumnFilters('mpNumber')"
                        [filterService]="filterService"
                        column="mpNumber"
                    ></mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element.mpNumber }}
                    </mat-cell>
                </ng-container>

                <!-- MPTitle Column -->
                <ng-container matColumnDef="mpTitle">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'columns.mpTitle' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <a
                            class="a-text-link-content"
                            [href]="'/projects/details/' + element.id"
                            target="_blank"
                            rel="noopener noreferrer"
                            >{{ element.mpTitle }}</a
                        >
                    </mat-cell>
                </ng-container>

                <!-- ProjektGruppierung Column -->
                <ng-container matColumnDef="projektGruppierung">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'columns.projektGruppierung' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element.projektGruppierung }}
                    </mat-cell>
                </ng-container>

                <!-- Project Lead Column -->
                <ng-container matColumnDef="projectLead.name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'columns.projectLead' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element.projectLead.name }}
                    </mat-cell>
                </ng-container>

                <!-- Business Partner Column-->
                <ng-container matColumnDef="businessPartner.fullName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>
                        {{ 'columns.businessPartnerSur' | translate }}
                    </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{ element.businessPartner.fullName }}
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
            </mat-table>
        </div>
        @if (projectSelectionService.total$ | async; as total) {
            <mat-paginator
                [length]="total"
                [pageSizeOptions]="[15, 30, 50, 100]"
                [pageSize]="projectSelectionService.pageSize"
                [pageIndex]="projectSelectionService.pageIndex"
                (page)="pageChanged($event)"
            ></mat-paginator>
        }
    </div>
</div>
@if (projectSelectionService.loading$ | async) {
    <ceres-loading [minimumHeight]="true" style="text-align: center"></ceres-loading>
}
<div class="row">
    <div class="d-flex flex-wrap justify-content-start gap-10">
        <button (click)="closeDialog()" class="a-button a-button--pwo a-icon a-icon--check-mark" type="button">
            {{ 'shared.buttons.apply' | translate }}
        </button>
        <button (click)="dialogRef.close()" class="a-button a-button--pwo a-icon a-icon--close" type="button">
            {{ 'shared.buttons.cancel' | translate }}
        </button>
    </div>
</div>
